import { CanDeactivateFn } from '@angular/router';

/** A page that holds edits back until they are saved. */
export interface ConfirmsLeave {
  /** True when it is fine to leave: nothing is unsaved, or the user chose to discard it. */
  confirmLeave(): boolean | Promise<boolean>;
}

/**
 * Asks before any route change away from a page with unsaved edits — a nav
 * link, the sign-out button, or the browser's back button. Reloading or
 * closing the tab never reaches the router; the page handles that itself with
 * `beforeunload`.
 */
export const unsavedChangesGuard: CanDeactivateFn<ConfirmsLeave> = component => component.confirmLeave();
